import * as actions from './actions';
import * as selectors from './selectors';
import reducer from './reducers';
import * as types from './types';
import sagas from './sagas';
import OtherDFSPsJWS from './OtherDFSPsJWS';

export default OtherDFSPsJWS;
export { actions, reducer, selectors, types, sagas };
